/* eslint-disable */
/*============================================================================
Start of cart-related functionality
==============================================================================*/
function ajaxSubmitCart() {
  $cart = $("#cart");
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    type: 'post',
    data: $cart.serialize(),
    success: function (data) {
    refreshCart(data);
    }
  });
}

function refreshCart(cart) {
  $cartBtn = $(".icon-cart span");

  if ($cartBtn && $cartBtn.size()) {
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var $cart = $("#cart ul");
    var cartSpecialMessage = "";

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
    $cart.find('li:not(:first)').remove();

    if (cart.item_count <= 0) {
      $cart.html('');
      $cart.append("<li class='empty_cart text-center'>Your Bag is Empty</li>");
      $(".cart-button").removeClass('itemincart');
      $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">' + cart.item_count + '</a>');
      $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));
      $(".addbag_count").hide();
    } else {
      $.each(cart.items, function(index, item) {
        cart_items_html += '';
        cart_items_html += '<li class="cart_item last_cart_item">' +
			 '<div class="cart_image">' +
             '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" style="width:100%" />' +
             '</div>' +
			 '<div class="cart_item_right" data-qty="'+ item.quantity +'" data-sku="'+ item.sku +'">' +
			 '<div class="item_title cart_item_title">' + item.title + '</div>' +
             '<div class="provar">' +
			 '<span style="display:inline-block;">' + item.variant_title + '</span>' +
             '</div>' +
			 '<div class="price item_price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) +'</div>' +
 			 '<div class="bottom_wrapper">' +
             '<span class="alabel">QTY: </span>' +
             '<div class="mm-counter cart-quantity">' +
             '<span class="quantity-count minus ss-icon minus">&#x002D;</span>' +
             '<input type="text" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" />' +
             '<span class="quantity-count plus ss-icon plus">&#x002B;</span>' +
             '</div>' +
             '<div class="removelink">' +
			 '<a href="javascript:void(0)" class="removelink_del" onclick="remove_item(' + item.variant_id + '); return false;">remove</a>' +
			 '</div>' +
			 '</div>' +
			 '</div>' +
			 '</li>' ;
      });

		  cart_items_html += '<div class="totals_wrapper"><div class="subtotal"> <span>ORDER SUBTOTAL</span>' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) +'</div>' + '<div class="col-md-12 text-center Cart_link"><a href="/cart">View Shopping Bag</a></div><div class="border_btn"><input type="submit" value="Proceed to checkout" class="action_button right"></div></div>';

      if ( $(".cart_item").length > 1) {
        // You were checking for the length of the current td instead of the length for td's with the same class
        $(".scrollbar").css('overflow-y', 'scroll');
      } else {
        $(".scrollbar").css('overflow-y', 'inherit');
      }

      $(".cart-button").addClass('itemincart');
      $(".cart-button").html(
        '<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">(' +cart.item_count+ ')</a>'
      );
      $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));
      $cart.html(cart_items_html);
      $cart.find('li.cart_item:last').addClass('last_cart_item');

      if ($('.currencies:visible option:selected').val()) {
        Currency.convertAll($cart.data('shop-currency'), $('.currencies:visible option:selected').val());
      }

      $(".slide_body").addClass('slideleft_body');
      $("#added-box-wrapper").fadeIn();

      $(".mobile_success_msg").fadeIn(1500);
      $(".mobile_success_msg").fadeOut(1500);

      if ($(window).width() < 767) {
        setTimeout(function() {
        }, 1200);
      }

      $(".addbag_count").show();
      $('.template-collection .modal').fadeOut();
      $('body').removeClass('modal-open');
      $('.close-reveal-modal').click();

      var wheight = $(window).height();
    	var header_height = $('#shopify-section-header').height();
    	var boxheight = $("#added-box-wrapper").innerHeight();
    	var total_height = $(".totals_wrapper ").innerHeight();

    	$("#added-box-wrapper").css('height', (wheight - header_height - 25));
  		$("#added-box ul").css('height', (boxheight - 207 - 20));

      setTimeout(function() {
        $("#added-box-wrapper").fadeOut();
      }, 2000);
    }
  }
}

function htmlEncode(value){
  if (value) {
      return $('<div/>').text(value).html();
  } else {
      return '';
  }
}

function remove_item(id) {
  document.getElementById('updates_'+id).value = 0;
  ajaxSubmitCart();
}

$(document).on("change", "#cart input", function() {
  ajaxSubmitCart();
});

$(document).on("click", ".minus", function() {
  var quantity = parseInt($(this).next("input").val());
  var qty = quantity ;

  quantity -= 1;
  $(this).next("input").attr("value", quantity);

  if (qty <= 0) {
    $(this).closest('li.cart_item').addClass('animated fadeOutUp')
    setTimeout(ajaxSubmitCart, 500);
  } else {
    ajaxSubmitCart();
  }
});

$(document).on("click", ".plus", function() {
  var quantity = parseInt($(this).prev("input").val());
  quantity += 1;
  $(this).prev("input").attr("value", quantity);
  ajaxSubmitCart();
});


$(document).on("submit",".product_form", function(e) {
  e.preventDefault();
  var $addToCartForm = $(this);
  var $addToCartSubmit = $addToCartForm.find('.product-form__cart-submit');
  var $addToCartBtn = $addToCartForm.find('.add_to_cart');
  $addToCartSubmit.addClass('loading-btn');

  var $sizeOptions = document.querySelectorAll('.pv-size__link');
  var hasSelection = false;
  var $selectSizeMessage = $('.select-size-msg');

  $sizeOptions.forEach(function(item) {
    if (item.classList.contains('is-selected')) {
      hasSelection = true;
      $selectSizeMessage.hide();
    }
  })

  if (hasSelection === true) {
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $addToCartForm.serialize(),
      success: function(itemData) {
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);

          window.setTimeout(function(){
            $('.cart-button').click();
            $addToCartSubmit.removeClass('loading-btn');
          }, 500);
        });
      },
      error: function(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        $('.warning').remove();

        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
        $addToCartBtn.after(warning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartSubmit.removeClass('loading-btn');
        $addToCartBtn.find('span').text("Add to Basket").removeClass('zoomOut').addClass('zoomIn');
      }
    });
  } else {
    $addToCartSubmit.removeClass('loading-btn');
    $selectSizeMessage.show();
  }

  return false;
});

/*
$(".cart-page-link").click(function(e) {
  	$("#added-box-wrapper").toggleClass("showcart");
  	$('.overlay_wrapper').show();
  	$("body").addClass('no-scroll');
  	e.stopPropagation();
});

$('.overlay_wrapper').on('click', function(e){
	$("#added-box-wrapper").removeClass("showcart");
  	$("body").removeClass('no-scroll');
  	$(this).hide();
});

$(".close_box").click(function(){
    $("#added-box-wrapper").removeClass("showcart");
  	$("body").removeClass('no-scroll');
  	$('.overlay_wrapper').hide();
});
*/
